import { FC } from 'react';
import { ContentHeading } from 'components/Typography';
import RefundOptionsCard from './RefundOptionsCard';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import QffBonus from '../QffBonus';

const RefundOptions: FC = () => {
  const { isEligibleForCreditNote } = useCancellationQuote();

  if (!isEligibleForCreditNote) {
    return null;
  }

  return (
    <>
      <ContentHeading>Refund options</ContentHeading>
      <QffBonus />
      <RefundOptionsCard />
    </>
  );
};

export default RefundOptions;
